export enum TaskStatus {
  Completed = 'completed',
  Uncompleted = 'uncompleted',
}

export enum TaskScope {
  My = 'my',
  All = 'all',
  Unassigned = 'unassigned',
  Admin = '',
}
